import { merge } from 'lodash-es';

export interface CalculationParams {
  initialPayoutRate: number;

  uwv: {
    // Maximum salary on first sick day (maximum SV loon)
    maximumSalary: number;
    // Minimum salary (wettelijk minimumloon)
    minimumSalary: number;

    // LGU Percentage of salary paid out by UWV
    lguPayoutPercent: number;
    // LGU minimum duration of payout in Months
    lguMinPayoutDuration: number;
    // LGU maximum duration of payout in Months
    lguMaxPayoutDuration: number;

    // VVU Cutoff percentage for remaining earnings capacity
    vvuCutoffPercent: number;
    // VVU Payout percentages (based on disability ratio)
    vvuPayoutPercentages: [number, number][];

    // LAU Cutoff percentage for remaining earnings capacity
    lauCutoffPercent: number;
    // LAU Payout percentage
    lauPayoutPercent: number;

    // IVA Payout percentage
    ivaPayoutPercent: number;
  };

  nvschade: {
    // Maximum insured amount under WIA-excedent insurance
    excedentMaximum: number;
    // Maximum insured amount under WIA-excedent TOP insurance
    excedentTopMaximum: number;

    // WBO Minimum salary loss required to be eligible
    wboMinimumSalaryLossRatio: number;

    // WHA percentage of capped salary to use
    whaCappedSalaryPercent: number;
    // WHA percentage of modified current income to use
    whaCurrentIncomePercent: number;
    // WHA premium as a percentage of income (capped at uwv.maximumSalary)
    whaPremium: number;

    // WEX percentage of capped salary to use
    wexCappedSalaryPercent: number;
    // WEX percentage of modified current income to use
    wexCurrentIncomePercent: number;

    // WEX percentage of capped salary to use when having to use IVA
    wexIvaCappedSalaryPercent: number;
    // WEX percentage of modified current income to use having to use IVA
    wexIvaCurrentIncomePercent: number;

    // WEX premium as a percentage of income (between uwv.maximumSalary and nvschade.excedentMaximum)
    wexPremium: number;

    // WET percentage of capped salary to use when having to use IVA
    wetIvaCappedSalaryPercent: number;
    // WET percentage of capped salary when not using IVA
    wetCappedSalaryPercent: number;
    // WET payout percentage lookup table
    wetPayoutPercentages: [number, number][];
  };
}

const params: CalculationParams = {
  initialPayoutRate: 0.9,

  uwv: {
    maximumSalary: 75864, // SV-loon maximum
    minimumSalary: 21835.01, // SV-loon minimum

    lguPayoutPercent: 0.7,
    lguMinPayoutDuration: 3,
    lguMaxPayoutDuration: 24,

    vvuCutoffPercent: 0.5,
    vvuPayoutPercentages: [
      [0.0, 0],
      [0.35, 0.28],
      [0.45, 0.35],
      [0.55, 0.42],
      [0.65, 0.5075],
    ],

    lauCutoffPercent: 0.5,
    lauPayoutPercent: 0.7,

    ivaPayoutPercent: 0.75,
  },

  nvschade: {
    excedentMaximum: 116729, // EV-loon
    excedentTopMaximum: 350186, // ET-loon

    wboMinimumSalaryLossRatio: 0.1,

    whaCappedSalaryPercent: 0.7,
    whaCurrentIncomePercent: 0.7,
    whaPremium: 0.00521, // WIA premie

    wexCappedSalaryPercent: 0.7,
    wexCurrentIncomePercent: 0.7,
    wexIvaCappedSalaryPercent: 0.75,
    wexIvaCurrentIncomePercent: 0.75,
    wexPremium: 0.0308, // WEX premie

    wetIvaCappedSalaryPercent: 0.7,
    wetCappedSalaryPercent: 0.7,
    wetPayoutPercentages: [
      [0.0, 0],
      [0.35, 0.4],
      [0.45, 0.5],
      [0.55, 0.6],
      [0.65, 0.725],
      [0.8, 1],
    ],
  },
};

export function loadFromGlobal() {
  if ('CALCULATOR_PARAMS' in window) {
    merge(params, window.CALCULATOR_PARAMS);
  }

  if (window.drupalSettings) {
    if ('nvschade_calculator' in window.drupalSettings) {
      merge(params, window.drupalSettings.nvschade_calculator);
    }
  }
}

export default params;
